App = App || {};

App.MemberDetail = (function ($, Vue) {
	"use strict";

	var $modal;

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("member-detail-app");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		$modal = $(rootElement).closest(".modal");

		new Vue({
			el: rootElement,
			data: {
				memberProfile: {
					id: "",
					firstName: '',
					middleInitial: '',
					lastName: '',
					street: '',
					city: '',
					postalCode: '',
					email: '',
					phone: '',
					phoneExt: '',
					securityQuestion: '',
					securityAnswer: '',
					prostaffPrograms: '',
					opticsUser: '',
					agreedToTerms: false,
					recaptchaToken: '',
					hobbies: [],
					timeInRetail: '',
					country: "USA",
					region: "",
					dealer: null,
					useCustomDealer: false,
					customDealer: {
						name: "",
						address: ""
					},
					sitefinityId: '',
					cardCode: '',
					lnAccountNo: '',
					salesforceAccountNo: '',
					notes: ''
				},
				countries: [],
				dealers: [],
				isLoading: false,
				isUnlocking: false,
				isUnlocked: false,
				isSubmitting: false,
				isComplete: false,
				alertMessage: "",
				alertErrors: []
			},

			computed: {
				currentCountry: function () {
					return this.countries.find(c => c.code === this.memberProfile.country);
				},
				currentRegions: function () {
					return this.currentCountry?.regions || [];
				},
				storeAddress: function () {
					return [this.memberProfile.dealer?.street, this.memberProfile.dealer?.city, this.memberProfile.dealer?.region]
						.filter(Boolean)
						.join(", ");
				}
			},

			methods: {
				formatDate: function (value) {
					if (!value)
						return "";
					var normalized = String(value).replace(/(\.\d{3})\d+$/, "$1");
					var d = new Date(normalized);
					return isNaN(d) ? String(value) : d.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
				},

				onCountryChange: function () {
					const selectedCountry = this.countries.find(c => c.code === this.memberProfile.country);
					this.memberProfile.region = (selectedCountry?.regions?.[0]?.code) || "";
				},

				formatDealerLabel: function (dealer) {
					if (!dealer)
						return "";

					return `${dealer.name} (${dealer.city}, ${dealer.state})`;
				},

				loadCountries: function () {
					$.ajax({
						url: "/api/countries",
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response.success) {
							this.countries = response.data;
							if (!this.memberProfile.region)
								this.onCountryChange();
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading countries:", status, err);
					});
				},

				loadDealers: function () {
					$.ajax({
						url: "/api/dealers/all",
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response.success) {
							this.dealers = response.data;
							const id = this.memberProfile.dealer?.id ?? null;
							this.memberProfile.dealer = this.dealers.find(d => d.id === id) || null;
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading dealers:", status, err);
					});
				},

				openAdjust: function (memberId) {
					$modal.off('hidden.bs.modal').one('hidden.bs.modal', function () {
						App.BalanceAdjustOffcanvas.open(memberId, () => $modal.modal("show"))
					});

					$modal.modal('hide');
				},

				openRoles: function (memberId) {
					$modal.off('hidden.bs.modal').one('hidden.bs.modal', function () {
						App.MemberRolesOffcanvas.open(memberId, () => $modal.modal("show"))
					});

					$modal.modal('hide');
				},

				close: function () {
					$modal.modal("hide");
				},

				loadProfile: function () {
					return $.ajax({
						url: "/api/members/" + encodeURIComponent(this.memberProfile.id),
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (!response || !response.success || !response.data) {
							this.alertMessage = (response && response.message) || "Failed loading profile.";
							return;
						}

						this.memberProfile = response.data;
						this.memberProfile.customDealer = this.memberProfile.customDealer || { name: "", address: "" };
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading profile:", status, err);
						this.alertMessage = "Failed loading profile.";
					});
				},

				scrollToFormTop() {
					this.$nextTick(() => {
						const topOffset = this.$el.getBoundingClientRect().top + window.pageYOffset - 20;
						window.scrollTo({ top: topOffset, behavior: 'smooth' });
						this.$refs.topAlert?.focus?.({ preventScroll: true });
					});
				},

				reset: function () {
					this.isSubmitting = false;
					this.isUnlocked = false;
					this.isUnlocking = false;
					this.isComplete = false;
					this.alertMessage = "";
					this.alertErrors = [];
				},

				save: function () {
					var form = this.$refs.form;
					if (!form.checkValidity()) {
						form.classList.add("was-validated");
						return;
					}

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];
					this.isComplete = false;

					$.ajax({
						url: "/api/members/",
						method: "PUT",
						contentType: "application/json",
						data: JSON.stringify(this.memberProfile)
					}).done(resp => {
						if (resp && resp.success) {
							this.isComplete = true;
							this.scrollToFormTop();
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (resp && resp.message) || "Save failed.";
							this.alertErrors = (resp && resp.data && resp.data.errors || []).map(e => e.description).filter(Boolean);
							form.classList.add("was-validated");
							this.scrollToFormTop();
						}
					}).fail(() => {
						this.alertMessage = "Save failed.";
						form.classList.add("was-validated");
						this.scrollToFormTop();
					}).always(() => {
						this.isSubmitting = false;
					});
				},

				unlock: function () {
					if (!this.memberProfile || !this.memberProfile.id)
						return;

					this.isUnlocking = true;
					this.alertMessage = "";
					this.alertErrors = [];

					$.ajax({
						url: "/api/members/unlock/" + encodeURIComponent(this.memberProfile.id),
						method: "GET",
						contentType: "application/json"
					}).done(resp => {
						if (resp && resp.success) {
							this.isUnlocked = true;
							setTimeout(() => {
								this.reset();
								this.loadProfile()
									.always(() => {
										this.loadCountries();
										this.loadDealers();
										this.isLoading = false;
									});
							}, 900);
						} else {
							this.alertMessage = (resp && resp.message) || "Unlock failed.";
							this.alertErrors = (resp && resp.data && resp.data.errors || []).map(e => e.description).filter(Boolean);
						}
					}).fail(() => {
						this.alertMessage = "Unlock failed.";
						form.classList.add("was-validated");
					}).always(() => {
						this.isUnlocking = false;
					});
				},

				deleteMember: function () {
					if (!this.memberProfile || !this.memberProfile.id)
						return;

					if (!window.confirm("Are you sure you want to delete this member? This action cannot be undone.")) {
						return;
					}

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];

					$.ajax({
						url: "/api/members/" + encodeURIComponent(this.memberProfile.id),
						method: "DELETE",
						dataType: "json"
					}).done(resp => {
						if (resp && resp.success) {
							this.close();
						} else {
							this.alertMessage = (resp && resp.message) || "Delete failed.";
							this.alertErrors = (resp && resp.data && resp.data.errors || []).map(e => e.description).filter(Boolean);
							this.scrollToFormTop();
						}
					}).fail(() => {
						this.alertMessage = "Delete failed.";
						this.scrollToFormTop();
					}).always(() => {
						this.isSubmitting = false;
					});
				}
			},

			mounted: function () {
				$modal.off("show.bs.modal hidden.bs.modal");

				$modal.on("show.bs.modal", () => {
					this.reset();
					this.memberProfile.id = $modal.data("id");
					this.loadProfile()
						.always(() => {
							this.loadCountries();
							this.loadDealers();
							this.isLoading = false;
						});
				});

				$modal.on("shown.bs.modal", () => {
					$modal.find("#close-icon").focus();
				});
			}
		});
	}

	function open(id, onClose) {
		$modal.data("id", id).modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}

	return { init, open };
})(jQuery, Vue);

App.MemberDetail.init();